import React from "react";
import { useDispatch } from "react-redux";
import { Delete, Edit } from "@mui/icons-material";
import RegularButton from "../../components/CustomButtons/Button";
import { ColumnContainer } from "../../utils/columnsStyle";
import { COVERAGE_GROUPS_CONFIG, COVERAGE_GROUPS_PHRASE } from "./config";
import {
  editCoverageGroupMode, setSelectedCoverageGroup, deleteCoverageGroupMode
} from "../../redux/actions/coverageGroups/coverageGroupsActions";

const blue = '#0055aa'

export const columns = [
  {
    Header: () => <span>{COVERAGE_GROUPS_CONFIG.name.label}</span>,
    accessor: COVERAGE_GROUPS_CONFIG.name.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COVERAGE_GROUPS_CONFIG.name.key]
        ? row[COVERAGE_GROUPS_CONFIG.name.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{COVERAGE_GROUPS_CONFIG.type.label}</span>,
    accessor: COVERAGE_GROUPS_CONFIG.type.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COVERAGE_GROUPS_CONFIG.type.key]
        ? row[COVERAGE_GROUPS_CONFIG.type.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal(true);
        dispatch(editCoverageGroupMode());
        dispatch(setSelectedCoverageGroup(original));
      };

      const openDelete = () => {
        original.deleteModal(true);
        dispatch(deleteCoverageGroupMode());
        dispatch(setSelectedCoverageGroup(original));
      }

      return (
        <ColumnContainer>
          <RegularButton
            tooltip={COVERAGE_GROUPS_PHRASE.page.table.actions.delete}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openDelete}
          >
            <Delete style={{ color: blue }} />
          </RegularButton>
          <RegularButton
            tooltip={COVERAGE_GROUPS_PHRASE.page.table.actions.edit}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openEdit}
          >
            <Edit style={{ color: blue }} />
          </RegularButton>
        </ColumnContainer>
      );
    },
  },
];
